<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 10/10/2020
  -->

<script>
	import {StepType} from "@shared/Program/ProgramStep/helpers/ProgramStepEnums";
	import {newNumberedName, ViewModeEnum} from "@/utils/helpers";

	import {classToClass} from "@qwoach/class-transformer-wrapper";
	import {debounce} from 'vue-debounce'
	import {deleteConfirmDialog} from '@/core/components/Dialogs/dialog'

	import {
		addContractDialog,
		createNoteDialog,
		createSectionDialog,
		createTaskDialog,
		editProgramItemDialog
	} from "@/core/modules/coach/Programs/Dialogs/dialog";
	import {SessionsCalendarSyncManager} from "@shared/scheduler/SessionsCalendarSyncManager";
	import {TimeBasedItemType} from "@shared/DueDatedItem/TimeBasedItemEnums";
	import TimeBasedItemManager from "@shared/DueDatedItem/TimeBasedItemManager";



	import BaseDataComponent from "@/core/components/BaseDataComponent.vue";
	import {messageDialogSimple} from "@/core/components/Dialogs/dialog";
	import CoachingSessionStep from "@shared/Program/ProgramStep/CoachingSessionStep";
	import {EventTypeCategory} from "@shared/scheduler/EventType";

	export default {
		extends: BaseDataComponent,
        name: "BaseProgramDetails",

		data () {
            return {
            	programItem: null,
				sessionType: null,
				clientList: [],
				timeBasedItemManager: null,
				sessionsCalendarSyncManager: null
            }
        },
		computed: {
			programId(){
				return this.$route.params.programId || this.$route.params.templateId
			},

			// ...mapState({
			// 	programDetailsItem: state => state.firebaseStore.programDetailsItem,
			// }),
			programDetailsItem(){
				return this.programItem
			},
			clientArray(){
				return this.clientList
			}

		},

		beforeUnmount(){
			this.stopListenForProgramChange()
		},

		methods: {


			setup(){
				this.timeBasedItemManager = new TimeBasedItemManager(this.$dataManager)

				this.sessionsCalendarSyncManager = new SessionsCalendarSyncManager(this.$dataManager)

				this.onBillingDataChangedDebounced = debounce(this.onBillingDataChangedDebounced, 5000)
				this.onProgramChangedWithNotificationDebounce = debounce(this.onProgramChangedWithNotification, 500)
			},

            async loadData(){
                console.log("created super")

				await this.startListenForProgramChange()
				console.log("program loaded")

				// let [programItem] = await Promise.all([
                //                 this.$dataManager.getProgram(this.programId),
                //             ])

				this.syncFutureRecurringSessionsIfNeeded(this.programDetailsItem)
				this.showItemDetailsIfNeeded();
			},

			async startListenForProgramChange(){
				console.log("startListenForProgramChange")
				if(this.programSnapshotListenerStop){
					console.warn("startListenForProgramChange: already running")
					return this.programItem
				}
				return await this.startListenForProgramChangeInternal()
			},

			startListenForProgramChangeInternal(){
				return new Promise((resolve, reject) => {
					this.programSnapshotListenerStop = this.$dataManager.onSnapshotProgram(this.programId, (programItem, error) => {
						if(error){
							this.stopListenForProgramChange()
							this.handleError(error)
							reject(error)
							return
						}
						this.programItem = programItem
						let fn = async () => {
							await this.onProgramSnapshotChange(programItem)
							resolve(programItem)
						}
						fn()
					})
				})
			},

			async onProgramSnapshotChange(programItem){
			},

			stopListenForProgramChange(){
				console.log("stopListenForProgramChange")
				if(this.programSnapshotListenerStop){
					this.programSnapshotListenerStop()
					this.programSnapshotListenerStop = null
				}
			},

			async syncFutureRecurringSessionsIfNeeded(programItem){
				let hasChanged = await this.sessionsCalendarSyncManager.showNewRecurringEventsIfNeeded(programItem, this.sessionType)
				if(hasChanged){
					this.$store.commit('setProgramDetailsItem', programItem)
					await this.onProgramChanged(programItem)
				}

			},

			async deleteProgramPromise(event, data, callback){
				let programItem = this.programDetailsItem
				let requestData = {
					program: programItem,
					userId: this.ownerProfile.id
				}
				await this.$dataManager.apiPostProgramDelete(requestData)
				await this.onProgramDeleted()
			},

			async onProgramDeleted(){
				await this.go("CoachingProcessMainCoach")
			},

			getProgramAnalyticsData(){
				let data = {}
				if(this.programItem){
					data = {
						program_name: this.programItem.name,
						client_name: this.programItem.headingTitle,
						id: this.programItem.id
					}
				}
				return data
			},

			async onProgramEditClicked(){
				let _ = this.$analyticManager.trackEvent("Coaching process edit clicked", this.getProgramAnalyticsData())
				let programTitle = await editProgramItemDialog({
					viewMode: ViewModeEnum.EDIT,
					dataItem: this.programDetailsItem,
					actionDelete: () => this.deleteProgramPromise()
				})
				let programItem = this.programDetailsItem
				console.log("onProgramEditClicked: programItem = ", programItem)

				if(programTitle && programItem && programItem.name !== programTitle){
					programItem.name = programTitle
					await this.onProgramTitleChanged(programTitle)
					return await this.onProgramChangedWithNotification()
				}
			},

			async onProgramTitleChanged(programTitle){

			},

			onClientEditingSettingsChanged(val){
				console.log("onClientEditingSettingsChanged: val = ", val)
				this.onProgramChangedWithNotificationDebounce()
			},

			async createSectionDialogFn(viewModeEnum = ViewModeEnum.ADD, dataItem){
				return await createSectionDialog({
					viewMode: viewModeEnum,
					dataItem: dataItem,
					programType: this.programDetailsItem.programType,
					actionDelete: () => this.deleteProgramStep(dataItem)
				})
			},

			async createCallDialogFn(viewModeEnum = ViewModeEnum.ADD, dataItem, sectionIndex){
            	console.log("createCallDialogFn: dataItem = ", dataItem)
				if(dataItem.schemaVersion  < 2){
					await this.handleAsyncBlocking(this.upgradeSessionStepSchemaFrom1to2(dataItem))
				}
				if(this.sessionType){
					dataItem.sessionTypeId = this.sessionType.id
				}
				if(!dataItem.sessionItemId){
					return await this.scheduleNewSession(dataItem, sectionIndex)
				} else {
					return await this.showExistingSession(dataItem, sectionIndex)
				}
				// return createCallDialog(viewModeEnum, dataItem, this.programDetailsItem, this.onEventReceived, this.programDetailsItem.programType, this.clientArray, sectionIndex)
			},

			async showExistingSession(dataItem, sectionIndex){
				console.log("showExistingSession")
			},

			async scheduleNewSession(dataItem, sectionIndex){
				console.log("scheduleNewSession")
			},

			createTaskDialogFn(viewModeEnum = ViewModeEnum.ADD, dataItem){
				console.log("createTaskDialogFn")
				return createTaskDialog({
					viewMode: viewModeEnum,
					dataItem: dataItem,
					programItem: this.programDetailsItem,
					eventFn: this.onEventReceived,
					programType: this.programDetailsItem.programType,
					clientList: this.clientArray,
					toggleCompletion: (data, clientProfile) => this.toggleTaskCompletion(data, clientProfile),
					onClientClicked: data => this.onClientClickedFromDialog(data),
					actionDelete: async (data) => {
						await this.deleteProgramStep(data)
						this.toast("Program updated successfully")
					}


			})

				// return createTaskDialog(viewModeEnum, dataItem, this.programDetailsItem, this.onEventReceived, this.programDetailsItem.programType, this.clientArray)
			},
			createNoteDialogFn(viewModeEnum = ViewModeEnum.ADD, dataItem){
				return createNoteDialog({
					viewMode: viewModeEnum,
					eventFn: this.onEventReceived,
					dataItem: dataItem,
					programType: this.programDetailsItem.programType,
					clientList: this.clientArray,
					actionDelete: async (data) => {
						await this.deleteProgramStep(data)
						this.toast("Note deleted")
					}
				})
			},
			addContractDialogFn(viewModeEnum = ViewModeEnum.ADD, dataItem){
				return addContractDialog({
					viewMode: viewModeEnum,
					dataItem: dataItem,
					programItem: this.programDetailsItem,
					eventFn: this.onEventReceived,
					programType: this.programDetailsItem.programType,
					clientList: this.clientArray,
					actionDelete: async (data) => {
						await this.deleteProgramStep(data)
						this.toast("Program updated successfully")
					}
				})
				// return addContractDialog(viewModeEnum, dataItem, this.programDetailsItem, this.onEventReceived, this.programDetailsItem.programType, this.clientArray)
			},
			showItemDetailsIfNeeded(){
				let itemId = this.$route.query.details
				if(itemId){
					this.showItemDetails(itemId)
				}
			},

			analyticsPropsMethod(){
				return {
					...this.programItem.analyticsProps()
				}
			},

			async showItemDetails(itemId){
				let detailsDialog = Promise.resolve();
				let item = this.programDetailsItem.findStepById(itemId);
				console.log("showItemDetails: item = ", item)
				if(!item){
					this.closeDetailsDialog()
					return;
				}
				let isEditable = this.isCoach || this.programDetailsItem.clientAccessSettings.canEdit//item.canEditBy(this.userProfile.id)
				let viewMode = isEditable ? ViewModeEnum.EDIT : ViewModeEnum.VIEW
				switch (item.stepType) {
					case StepType.TASK:
						detailsDialog = this.createTaskDialogFn(viewMode, item);
						break;
					case StepType.CALL:
						detailsDialog = this.createCallDialogFn(viewMode, item);
						break;
					case StepType.SECTION:
						detailsDialog = this.createSectionDialogFn(viewMode, item);
						break;
					case StepType.NOTE:
						detailsDialog = this.createNoteDialogFn(viewMode, item);
						break;
					case StepType.CONTRACT:
						detailsDialog = this.addContractDialogFn(viewMode, item);
						break;
					default:
						throw new Error("showItemDetails: stepType not found: item = ", item)
				}

				try{
					let programStep = await detailsDialog
					if(programStep){
						await this.updateProgramStep(programStep)
						this.toast("Program updated successfully");
					}
					// this.closeDetailsDialog();
				} catch (error) {
					//this is where "close" dialog also happens... not cool, this needs a better approach
					// this.closeDetailsDialog();
				}
			},
			closeDetailsDialog(){
				this.removeQuery(['details'])
			},
			updateProgramStep(programStep){
            	if(programStep){
					this.programDetailsItem.setStepById(programStep.id, programStep)
					return this.onProgramChanged(this.programDetailsItem);
				}
			},
			deleteProgramStep(programStep, showSuccessToast){
				this.programDetailsItem.deleteStepById(programStep.id, programStep)
				return this.onProgramChanged(this.programDetailsItem, showSuccessToast);
			},

			onSectionClicked(section){
				this.onProgramItemClicked(section)
			},

			async onSectionDeleteClicked(section){
				let coachingSessionSteps = section.subStepList.filter(step => step.isTypeCall())
				if(coachingSessionSteps.length > 0){
					await messageDialogSimple("Can't delete section", "Can't delete this section because it contains a coaching session. <br/><br/>Please delete all coaching sessions in this section first.")
					return false
				}

				let res = await deleteConfirmDialog({
					itemName: "section"
				})

				if(res){
					await this.deleteProgramStep(section, true)
				}
			},


			async onProgramItemClicked(programStep){
				console.log("onProgramItemClicked: programStep = ", programStep)
				return this.showItemDetails(programStep.id)
			},

			onEventReceived(event, data, clientProfile){
				console.log("onEventReceived: event = ", event, ", data = ", data, ", clientProfile = ", clientProfile)
				console.log("onEventReceived: dataJson = ", JSON.stringify(data))
				switch (event) {
					case 'programChanged':
						return this.onProgramChanged(data)
					case 'stepChanged':
						return this.updateProgramStep(data)
					case 'onDeleteItem':
						return this.deleteProgramStep(data).then(_ => this.toast("Program updated successfully"))
					case 'onBeforeSchedule':
						return this.createProgramStep(data.dataItem, data.sectionIndex)
								.then(_ => this.onProgramItemClicked(data.dataItem))
				}
				return Promise.resolve()
			},
			onClientClickedFromDialog(clientProfile){

			},
			async toggleTaskCompletion(taskItem, clientProfile = this.userProfile){
				let task = this.programDetailsItem.findStepById(taskItem.id)
				task.toggleCompletedBy(clientProfile)
				let isCompleted = task.isCompletedBy(clientProfile.id)
				await this.timeBasedItemManager.syncTimeBasedItem(task, TimeBasedItemType.ACTION_ITEM, timeBasedItem => {
					timeBasedItem.isCompleted = isCompleted
					return timeBasedItem
				})
				let _ = this.$analyticManager.trackEvent("Toggle task completion", {value: isCompleted, ...this.getProgramAnalyticsData()})
				await this.onProgramChanged()
				let msg = "Program updated successfully";
				if(isCompleted){
					msg = "Task completed successfully"
				}
				this.toast(msg)
				return isCompleted
			},

			async upgradeSessionStepSchemaFrom1to2(dataItem){
				let [sessionTypes, sessionItems] = await Promise.all([
					this.$dataManager.findSessionTypeByOwnerId(dataItem.id, EventTypeCategory.PROGRAM),
					this.$dataManager.findScheduledSessionsByOwnerId(dataItem.id)
				])

				let sessionType = sessionTypes[0]
				let sessionItem = sessionItems[0]

				if(sessionType){
					dataItem.sessionTypeId = sessionType.id
				}
				if(sessionItem){
					dataItem.sessionItemId = sessionItem.id
				}
				dataItem.schemaVersion = 2
				console.log("loadData: legacy data: dataItem = ", dataItem)
				await this.onProgramChanged()
			},


			async addSectionClicked(showSuccessToast) {
            	console.log("addSectionClicked2")
				let programSteps = this.programItem.programSteps
				let data
				if(programSteps.length < 2){
					data = await this.createSectionDialogFn(ViewModeEnum.ADD)
				} else {
					let lastProgramStep = programSteps[programSteps.length - 1]
					let newName = newNumberedName(lastProgramStep.name, 1)
					let newProgramStep = classToClass(lastProgramStep)
					newProgramStep.resetId()
					newProgramStep.name = newName
					newProgramStep.subStepList = []
					data = newProgramStep
				}
				return await this.createProgramSection(data, showSuccessToast)

			},

			async addSectionWithSessionClicked(){
				let section = await this.handleAsyncBlocking(this.addSectionClicked())
				if(section){
					let index = this.programItem.programSteps.length - 1
					await this.addCallClicked(index)
				}
			},

			async addCallClicked(sectionIndex) {
				if(!this.sessionType){
					return await messageDialogSimple("Session is not setup.", "It seems like your coach haven't added sessions in their dashboard.<br/><br/>Please contact your coach asking them to visit their dashboard and setup sessions for this coaching program.")
				}
				let sessionStep = new CoachingSessionStep()
				sessionStep.schemaVersion = 2
				sessionStep.suggestedTimeOwnerUid = this.ownerProfile.id

				let sectionItem = this.programItem.programSteps[sectionIndex]
				sectionItem.subStepList.unshift(sessionStep)
				await this.handleAsyncBlocking(this.onProgramChanged())
				let data = await this.createCallDialogFn(ViewModeEnum.ADD, sessionStep, sectionIndex)
				await this.updateProgramStep(data)
			},

			async addProgramTaskClicked(sectionIndex) {
				let data = await this.createTaskDialogFn(ViewModeEnum.ADD)
				await this.createProgramStep(data, sectionIndex)
			},
			async addNoteClicked(sectionIndex){
				let data = await this.createNoteDialogFn(ViewModeEnum.ADD)
				await this.createProgramStep(data, sectionIndex)
			},

			async onAddContractClicked(sectionIndex){
				let data = await this.addContractDialogFn(ViewModeEnum.ADD)
				await this.createProgramStep(data, sectionIndex)
			},

			async onPaymentSuccess(){
				// this.programItem = await this.handleAsyncNonBlocking(this.$dataManager.getProgram(this.programId))
				this.toast("Payment completed successfully")
			},

			async createProgramStep(programStep, sectionIndex) {
            	console.log("createProgramStep: sectionIndex = ", sectionIndex, ", programStep = ", programStep)
				if(programStep){
					this.programDetailsItem.addProgramStep(programStep, sectionIndex)
					return await this.onProgramChanged(this.programDetailsItem);
				}
			},

			async createProgramSection(programSection, showSuccessToast = true) {
				console.log("createProgramSection = ", programSection)
            	if(programSection){
					this.programDetailsItem.addSection(programSection)
					let count = this.programDetailsItem.programSteps.length;
					this.$refs.programAgenda.expandSection(count - 1)
					this.$refs.programAgenda.syncExpandedItemsFromProgram()
					await this.onProgramChanged(this.programDetailsItem, showSuccessToast)
				}
				return programSection
			},

			async onProgramChangedWithNotification(programDetailsItem){
				await this.onProgramChanged(programDetailsItem, true)
			},

			async onProgramChanged(programDetailsItem, showSuccessToast){
				if(!programDetailsItem){
					programDetailsItem = this.programDetailsItem;
				}
				console.log("onProgramChanged: programDetailsItem = ", programDetailsItem)

				try{
					let programItem = await this.handleAsyncNonBlocking(this.$dataManager.updateProgram(programDetailsItem))

					// TODO this is to trigger "deep watch" and rerender on update. Need to find a better way
					this.programItem = classToClass(programItem)

					if(showSuccessToast){
						this.toast("Program was updated successfully")
					}
				} catch (error){
					this.handleError(error, "Something went wrong. Can't update program. Please try again.");
					throw error;
				}
			},

			onBillingDataChanged(billingData, billingView){
				console.log("onBillingDataChanged: billingData = ", billingData)
				this.billingData = billingData
				this.programItem.syncPaymentLockerFromBillingData(this.billingData, this.invoices)
				this.onBillingDataChangedDebounced(billingData, billingView)
			},

			async onBillingDataChangedDebounced(billingData, billingView){
				console.log("onBillingDataChangedDebounce: billingData = ", billingData)
				billingView.saveStarted()

				let totalAmount = billingData.totalAmount()
				let totalAmountPaid = billingData.totalAmountPaid(this.invoices)
				this.programDetailsItem.billingAmountTotal = totalAmount
				this.programDetailsItem.billingAmountPaid = totalAmountPaid
				await this.onProgramChanged()

				try{
					await this.$dataManager.setBillingData(billingData)
					billingView.saveSuccess()
				} catch (error){
					billingView.saveFailed()
					this.handleError(error)
				}
			}
		}

	}
</script>

<style>

</style>
